import e from "./CodeExample.vue.script.js";
/* empty css                          */
import t from "../../_virtual/_plugin-vue_export-helper.js";
//#region src/code-example/components/CodeExample.vue
var n = /*#__PURE__*/ t(e, [["__scopeId", "data-v-8b0cd212"]]);
//#endregion
export { n as default };

//# sourceMappingURL=CodeExample.vue.js.map